import React, {
  useEffect,
  useMemo,
  useRef,
  useState,
} from "react";

import Card from "@material-ui/core/Card";
import CardContent from "@material-ui/core/CardContent";
import Typography from "@material-ui/core/Typography";

import {
  Row,
  Col,
  Input,
  Label,
  Button,
} from "reactstrap";

import {
  WhatsApp,
  Visibility,
  Image as ImageIcon,
  Close as CloseIcon,
  Search as SearchIcon,
  Message as MessageIcon,
  Redeem as RedeemIcon,
  LocalShipping as LocalShippingIcon,
  Stars as StarsIcon,
  Build as BuildIcon,
  Event as EventIcon,
  ShoppingCart as ShoppingCartIcon,
  Edit as EditIcon,
  Refresh as RefreshIcon,
} from "@material-ui/icons";

import { useLocation } from "react-router-dom";

import axios from "axios";

import "../../../../_assets/css/whatsapp.css";
import { postMethod } from "../../../../_services/_postMethod";
import { API_BASE_URL } from "../../../../_services/constant";

const WhatsAppTemplate = () => {
  const location = useLocation();

  const queryParams = new URLSearchParams(
    location.search
  );

  const branchId =
    queryParams.get("branch_id") ||
    localStorage.getItem("jwl_branch_id");

  const companyLogo =
    API_BASE_URL +
    "BranchLogo/" +
    localStorage.getItem("jwl_company_logo");

  // =========================================================
  // STATES
  // =========================================================

  const [templates, setTemplates] = useState([]);

  const [search, setSearch] = useState("");

  const [loading, setLoading] = useState(false);

  const [updatingTemplate, setUpdatingTemplate] =
    useState({});

  const [selectedTemplate, setSelectedTemplate] =
    useState(null);

  const [viewModal, setViewModal] = useState(false);

  const [variableValues, setVariableValues] =
    useState({});

  const [templateImages, setTemplateImages] =
    useState({});

  // Branch logo
  const [logo, setLogo] = useState("");

  const fileInputRefs = useRef({});

  // =========================================================
  // GET BRANCH LOGO
  // =========================================================

  const getBranchLogo = async () => {
    try {
      const response = await postMethod(
        "api/customervisit/get_branch_logo"
      );

      const data =
        response?.data?.data ||
        response?.data;

      if (
        Array.isArray(data) &&
        data.length > 0
      ) {
        setLogo(data[0]?.logo || "");
      } else if (
        response?.data?.length > 0
      ) {
        setLogo(
          response.data[0]?.logo || ""
        );
      }
    } catch (error) {
      console.error(
        "Error while fetching branch logo:",
        error
      );

      setLogo("");
    }
  };

  // =========================================================
  // GET TEMPLATES
  // =========================================================

  const getTemplates = async () => {
    setLoading(true);

    try {
      const response = await postMethod(
        "api/sms/template/variable/preview",
        {
          branch_id: branchId,
        }
      );

      const responseData =
        response?.data;

      let data = [];

      if (Array.isArray(responseData)) {
        data = responseData;
      } else if (
        Array.isArray(responseData?.data)
      ) {
        data = responseData.data;
      } else if (
        Array.isArray(responseData?.result)
      ) {
        data = responseData.result;
      }

      setTemplates(data);

      // =====================================================
      // LOAD EXISTING VALUES
      // =====================================================

      const variableState = {};
      const imageState = {};

      data.forEach((item) => {
        const key =
          item.whatsapp_template_id ||
          item.template_id ||
          item.template_type;

        variableState[key] = {};

        for (let i = 1; i <= 5; i++) {
          const dbValue =
            item[`variable_${i}`];

          if (
            dbValue !== null &&
            dbValue !== undefined &&
            dbValue !== ""
          ) {
            variableState[key][i - 1] =
              dbValue;
          }
        }

        // ===================================================
        // EXISTING IMAGE
        // ===================================================

        if (item.template_img) {
          let imageUrl =
            item.template_img;

          /*
           * Agar backend relative path bhej raha hai
           * to API_BASE_URL ke saath complete URL bana denge.
           */

          if (
            imageUrl &&
            !imageUrl.startsWith("http://") &&
            !imageUrl.startsWith("https://") &&
            !imageUrl.startsWith("blob:")
          ) {
            imageUrl =
              API_BASE_URL.replace(
                /\/$/,
                ""
              ) +
              "/" +
              imageUrl.replace(
                /^\//,
                ""
              );
          }

          imageState[key] = {
            file: null,
            url: imageUrl,
            name: String(
              item.template_img
            )
              .split("/")
              .pop(),
            isExisting: true,
          };
        }
      });

      setVariableValues(
        variableState
      );

      setTemplateImages(
        imageState
      );
    } catch (error) {
      console.error(
        "Error while fetching WhatsApp templates:",
        error
      );

      setTemplates([]);
    } finally {
      setLoading(false);
    }
  };

  // =========================================================
  // INITIAL LOAD
  // =========================================================

  useEffect(() => {
    if (branchId) {
      getTemplates();
      getBranchLogo();
    }
  }, [branchId]);

  // =========================================================
  // EXTRACT VARIABLES
  // =========================================================

  const extractVariables = (
    template = ""
  ) => {
    const matches =
      template.match(/\$[^$]*\$/g);

    if (!matches) {
      return [];
    }

    return matches.slice(0, 5);
  };

  // =========================================================
  // TEMPLATE KEY
  // =========================================================

  const getTemplateKey = (
    template
  ) => {
    return (
      template?.whatsapp_template_id ||
      template?.template_id ||
      template?.template_type
    );
  };

  // =========================================================
  // TEMPLATE ICON
  // =========================================================

  const getTemplateIcon = (
    templateType = ""
  ) => {
    const type = String(
      templateType
    ).toLowerCase();

    if (
      type.includes("voucher") ||
      type.includes("coupon")
    ) {
      return <RedeemIcon />;
    }

    if (
      type.includes("stock") ||
      type.includes("transfer")
    ) {
      return <LocalShippingIcon />;
    }

    if (
      type.includes("point") ||
      type.includes("redeem")
    ) {
      return <StarsIcon />;
    }

    if (
      type.includes("service") ||
      type.includes("repair")
    ) {
      return <BuildIcon />;
    }

    if (
      type.includes("appointment") ||
      type.includes("birthday") ||
      type.includes("anniversary")
    ) {
      return <EventIcon />;
    }

    if (
      type.includes("sale") ||
      type.includes("order")
    ) {
      return <ShoppingCartIcon />;
    }

    return <MessageIcon />;
  };

  // =========================================================
  // TEMPLATE CSS CLASS
  // =========================================================

  const getTemplateClass = (
    templateType = ""
  ) => {
    const type = String(
      templateType
    ).toLowerCase();

    if (
      type.includes("voucher") ||
      type.includes("coupon")
    ) {
      return "template-voucher";
    }

    if (
      type.includes("stock") ||
      type.includes("transfer")
    ) {
      return "template-stock";
    }

    if (
      type.includes("point") ||
      type.includes("redeem")
    ) {
      return "template-point";
    }

    if (
      type.includes("service") ||
      type.includes("repair")
    ) {
      return "template-service";
    }

    if (
      type.includes("appointment") ||
      type.includes("birthday") ||
      type.includes("anniversary")
    ) {
      return "template-appointment";
    }

    if (
      type.includes("sale") ||
      type.includes("order")
    ) {
      return "template-sale";
    }

    return "template-default";
  };

  // =========================================================
  // VARIABLE CHANGE
  // =========================================================

  const handleVariableChange = (
    templateKey,
    variableIndex,
    value
  ) => {
    setVariableValues((prev) => ({
      ...prev,

      [templateKey]: {
        ...(prev[templateKey] || {}),
        [variableIndex]: value,
      },
    }));
  };

  // =========================================================
  // ACTIVE CHECKBOX
  // =========================================================

  const handleActiveChange = (
    template,
    checked
  ) => {
    setTemplates((prev) =>
      prev.map((item) => {
        const itemKey =
          item.whatsapp_template_id ||
          item.template_id ||
          item.template_type;

        const currentKey =
          template.whatsapp_template_id ||
          template.template_id ||
          template.template_type;

        if (itemKey === currentKey) {
          return {
            ...item,
            is_active: checked ? 1 : 0,
          };
        }

        return item;
      })
    );
  };

  // =========================================================
  // IMAGE SELECT
  // =========================================================

  const handleImageSelect = (
    event,
    template
  ) => {
    const file =
      event.target.files?.[0];

    if (!file) {
      return;
    }

    // IMAGE VALIDATION
    if (
      !file.type.startsWith("image/")
    ) {
      alert(
        "Please select an image file."
      );

      event.target.value = "";

      return;
    }

    // 5 MB LIMIT
    if (
      file.size >
      5 * 1024 * 1024
    ) {
      alert(
        "Image size should not exceed 5 MB."
      );

      event.target.value = "";

      return;
    }

    const templateKey =
      getTemplateKey(template);

    // OLD BLOB CLEANUP
    if (
      templateImages[templateKey]?.url &&
      !templateImages[templateKey]
        ?.isExisting
    ) {
      URL.revokeObjectURL(
        templateImages[templateKey]
          .url
      );
    }

    // CREATE PREVIEW
    const imageUrl =
      URL.createObjectURL(file);

    setTemplateImages((prev) => ({
      ...prev,

      [templateKey]: {
        file: file,
        url: imageUrl,
        name: file.name,
        isExisting: false,
      },
    }));

    event.target.value = "";
  };

  // =========================================================
  // REMOVE IMAGE
  // =========================================================

  const handleRemoveImage = (
    template
  ) => {
    const templateKey =
      getTemplateKey(template);

    if (
      templateImages[templateKey]?.url &&
      !templateImages[templateKey]
        ?.isExisting
    ) {
      URL.revokeObjectURL(
        templateImages[templateKey]
          .url
      );
    }

    setTemplateImages((prev) => {
      const updated = {
        ...prev,
      };

      delete updated[templateKey];

      return updated;
    });

    if (
      fileInputRefs.current[
        templateKey
      ]
    ) {
      fileInputRefs.current[
        templateKey
      ].value = "";
    }
  };

  // =========================================================
  // OPEN IMAGE SELECTOR
  // =========================================================

  const openImageSelector = (
    template
  ) => {
    const templateKey =
      getTemplateKey(template);

    if (
      fileInputRefs.current[
        templateKey
      ]
    ) {
      fileInputRefs.current[
        templateKey
      ].click();
    }
  };

  // =========================================================
  // RESET
  // =========================================================

  const handleResetTemplate = async (
    template
  ) => {
    const templateKey =
      getTemplateKey(template);

    if (
      templateImages[templateKey]?.url &&
      !templateImages[templateKey]
        ?.isExisting
    ) {
      URL.revokeObjectURL(
        templateImages[templateKey]
          .url
      );
    }

    setVariableValues((prev) => {
      const updated = {
        ...prev,
      };

      delete updated[templateKey];

      return updated;
    });

    setTemplateImages((prev) => {
      const updated = {
        ...prev,
      };

      delete updated[templateKey];

      return updated;
    });

    if (
      fileInputRefs.current[
        templateKey
      ]
    ) {
      fileInputRefs.current[
        templateKey
      ].value = "";
    }

    await getTemplates();
  };

  // =========================================================
  // UPDATE TEMPLATE
  // =========================================================

const updateTemplate = async (template) => {
  const templateKey = getTemplateKey(template);

  if (updatingTemplate[templateKey]) {
    return;
  }

  

  setUpdatingTemplate((prev) => ({
    ...prev,
    [templateKey]: true,
  }));

  try {
    const image = templateImages[templateKey];

    const values = variableValues[templateKey] || {};

    // =====================================================
    // 1. IMAGE CHECK
    // =====================================================

    if (!image?.file) {
      alert("Please select an image.");

      setUpdatingTemplate((prev) => ({
        ...prev,
        [templateKey]: false,
      }));

      return;
    }

    const file = image.file;

    // =====================================================
    // 2. FORM DATA
    // =====================================================

    const formData = new FormData();

// IMAGE
formData.append("file", file);
for (const [key, value] of formData.entries()) {
  console.log(
    "FORM DATA:",
    key,
    value
  );
}

    // TEMPLATE DATA
   
 formData.append(
      "template_img",
      file?.name || ""
    );
    formData.append(
      "template_id",
      template.template_id || ""
    );

    formData.append(
      "branch_id",
      String(branchId)
    );

    formData.append(
      "template_type",
      template.template_type || ""
    );

    formData.append(
      "variable_1",
      values[0] || ""
    );

    formData.append(
      "variable_2",
      values[1] || ""
    );

    formData.append(
      "variable_3",
      values[2] || ""
    );

    formData.append(
      "variable_4",
      values[3] || ""
    );

    formData.append(
      "variable_5",
      values[4] || ""
    );

    formData.append(
      "is_active",
      Number(template.is_active) === 1
        ? "1"
        : "0"
    );

    // =====================================================
    // 3. UPLOAD + UPDATE API
    // =====================================================

    const uploadUrl =
      `${API_BASE_URL}api/masters/template/uploadImageTEMP`;

      const response = await axios.post(
  uploadUrl,
  formData,
  {
    headers: {
      "auth-token":
        localStorage.getItem("jwl_token"),
    },
  }
);
    

    console.log(
      "UPLOAD/UPDATE RESPONSE:",
      response
    );

    // =====================================================
    // 4. SUCCESS
    // =====================================================

    if (
      response?.data?.status === 200 ||
      response?.status === 200
    ) {
      alert(
        `${template.template_type} template updated successfully.`
      );

      await getTemplates();
    } else {
      alert(
        response?.data?.message ||
        "Something Went Wrong"
      );
    }
  } catch (error) {
    console.error(
      "Template Update Error:",
      error
    );

    console.error(
      "Update Response:",
      error?.response?.data
    );

    alert(
      error?.response?.data?.message ||
      "An error occurred while updating the template."
    );
  } finally {
    setUpdatingTemplate((prev) => ({
      ...prev,
      [templateKey]: false,
    }));
  }
};

  // =========================================================
  // VIEW TEMPLATE
  // =========================================================

  const handleViewTemplate = (
    template
  ) => {
    setSelectedTemplate(
      template
    );

    setViewModal(true);
  };

  // =========================================================
  // CLOSE MODAL
  // =========================================================

  const closeViewModal = () => {
    setViewModal(false);

    setSelectedTemplate(null);
  };

  // =========================================================
  // RENDER PREVIEW TEXT
  // =========================================================

  const renderPreviewText = (
    template
  ) => {
    if (!template) {
      return null;
    }

    const templateKey =
      getTemplateKey(template);

    const values =
      variableValues[
        templateKey
      ] || {};

    const text =
      template.template || "";

    const parts =
      text.split(
        /(\$[^$]*\$)/g
      );

    let variableIndex = 0;

    return parts.map(
      (part, index) => {
        if (
          part.startsWith("$") &&
          part.endsWith("$")
        ) {
          const currentIndex =
            variableIndex;

          const value =
            values[
              currentIndex
            ] || "";

          variableIndex++;

          if (value) {
            return (
              <span
                key={index}
                className="wa-preview-variable-filled"
              >
                {value}
              </span>
            );
          }

          return (
            <span
              key={index}
              className="wa-preview-variable"
            >
              {part}
            </span>
          );
        }

        return (
          <React.Fragment
            key={index}
          >
            {part}
          </React.Fragment>
        );
      }
    );
  };

  // =========================================================
  // LOGO URL
  // =========================================================

  const getLogoUrl = () => {
    if (!logo) {
      return "";
    }

    if (
      logo.startsWith("http://") ||
      logo.startsWith("https://") ||
      logo.startsWith("blob:")
    ) {
      return logo;
    }

    return (
      API_BASE_URL.replace(
        /\/$/,
        ""
      ) +
      "/" +
      logo.replace(/^\//, "")
    );
  };

  // =========================================================
  // SEARCH
  // =========================================================

  const filteredTemplates =
    useMemo(() => {
      const searchValue =
        search
          .trim()
          .toLowerCase();

      if (!searchValue) {
        return templates;
      }

      return templates.filter(
        (template) =>
          String(
            template.template_type ||
              ""
          )
            .toLowerCase()
            .includes(
              searchValue
            )
      );
    }, [
      templates,
      search,
    ]);

  // =========================================================
  // CLEANUP BLOB URLS
  // =========================================================

  useEffect(() => {
    return () => {
      Object.keys(
        templateImages
      ).forEach((key) => {
        if (
          templateImages[key]
            ?.url &&
          !templateImages[key]
            ?.isExisting
        ) {
          URL.revokeObjectURL(
            templateImages[key]
              .url
          );
        }
      });
    };
  }, []);

  // =========================================================
  // LOADING
  // =========================================================

  if (loading) {
    return (
      <div className="wa-page">
        <div className="wa-loading">
          <div className="wa-loading-spinner"></div>

          <Typography>
            Loading WhatsApp templates...
          </Typography>
        </div>
      </div>
    );
  }

  // =========================================================
  // MAIN JSX
  // =========================================================

  return (
    <div className="wa-page">

      {/* =====================================================
          HEADER
      ====================================================== */}

      <div className="wa-header">

        <div className="wa-header-left">

          <div className="wa-header-icon">
            <WhatsApp />
          </div>

          <div>

            <Typography
              variant="h5"
              className="wa-header-title"
            >
              WhatsApp Templates
            </Typography>

            <Typography
              variant="body2"
              className="wa-header-subtitle"
            >
              Manage your branch WhatsApp
              message templates
            </Typography>

          </div>

        </div>

        <div className="wa-count">
          {filteredTemplates.length}{" "}
          Templates
        </div>

      </div>

      {/* =====================================================
          SEARCH
      ====================================================== */}

      <div className="wa-toolbar">

        <Row className="align-items-center">

          <Col
            md="8"
            sm="12"
          >

            <div
              style={{
                position:
                  "relative",
              }}
            >

              <SearchIcon
                style={{
                  position:
                    "absolute",
                  left: "10px",
                  top: "10px",
                  fontSize:
                    "20px",
                  color:
                    "#8a969c",
                  zIndex: 1,
                }}
              />

              <Input
                type="text"
                value={search}
                onChange={(e) =>
                  setSearch(
                    e.target.value
                  )
                }
                placeholder="Search by template type..."
                className="wa-search-input"
                style={{
                  paddingLeft:
                    "38px",
                }}
              />

            </div>

          </Col>

          <Col
            md="4"
            sm="12"
            className="text-md-right mt-2 mt-md-0"
          >

            <span className="wa-count">

              Showing{" "}
              {
                filteredTemplates.length
              }{" "}
              of{" "}
              {templates.length}

            </span>

          </Col>

        </Row>

      </div>

      {/* =====================================================
          EMPTY
      ====================================================== */}

      {filteredTemplates.length ===
      0 ? (

        <div className="wa-empty">

          <div className="wa-empty-icon">
            <WhatsApp />
          </div>

          <Typography variant="h6">
            No WhatsApp templates
            found
          </Typography>

          <Typography variant="body2">
            {search
              ? "Try another template type."
              : "No WhatsApp templates are available."}
          </Typography>

        </div>

      ) : (

        <Row>

          {filteredTemplates.map(
            (
              template,
              index
            ) => {

              const templateKey =
                getTemplateKey(
                  template
                );

              const variables =
                extractVariables(
                  template.template
                );

              const selectedImage =
                templateImages[
                  templateKey
                ];

              const isActive =
                Number(
                  template.is_active
                ) === 1;

              const isUpdating =
                updatingTemplate[
                  templateKey
                ];

              return (

                <Col
                  key={
                    templateKey ||
                    index
                  }
                  lg="4"
                  md="6"
                  sm="12"
                  className="mb-4"
                >

                  <Card
                    className={`wa-template-card ${getTemplateClass(
                      template.template_type
                    )}`}
                  >

                    {/* =================================================
                        CARD HEADER
                    ================================================== */}

                    <div className="wa-template-top">

                      <div className="wa-template-heading">

                        <div className="wa-template-icon">
                          {getTemplateIcon(
                            template.template_type
                          )}
                        </div>

                        <div>

                          <Typography
                            className="wa-template-name"
                          >
                            {
                              template.template_type ||
                              "WhatsApp Template"
                            }
                          </Typography>

                          <Typography
                            className="wa-template-id"
                          >
                            {
                              template.template_id
                            }
                          </Typography>

                        </div>

                      </div>

                      {/* ACTIVE */}

                      <div
                        style={{
                          display:
                            "flex",
                          alignItems:
                            "center",
                          gap: "5px",
                        }}
                      >

                        <Input
                          type="checkbox"
                          checked={
                            isActive
                          }
                          onChange={(
                            e
                          ) =>
                            handleActiveChange(
                              template,
                              e.target.checked
                            )
                          }
                          style={{
                            width:
                              "18px",
                            height:
                              "18px",
                            cursor:
                              "pointer",
                            margin: 0,
                          }}
                        />

                        <span
                          style={{
                            fontSize:
                              "12px",
                            fontWeight:
                              600,
                            color:
                              isActive
                                ? "#198754"
                                : "#999",
                          }}
                        >
                          {isActive
                            ? "Active"
                            : "Inactive"}
                        </span>

                      </div>

                    </div>

                    {/* =================================================
                        CARD BODY
                    ================================================== */}

                    <CardContent className="wa-template-body">

                      {/* VARIABLES */}

                      <div className="wa-variable-title">

                        <MessageIcon
                          style={{
                            fontSize:
                              "15px",
                          }}
                        />

                        Template Variables

                      </div>

                      {variables.length ===
                      0 ? (

                        <div className="wa-no-variable">
                          This template has
                          no variables.
                        </div>

                      ) : (

                        variables.map(
                          (
                            variable,
                            variableIndex
                          ) => (

                            <div
                              className="wa-variable-box"
                              key={`${templateKey}-${variableIndex}`}
                            >

                              <Label className="wa-variable-label">

                                Variable{" "}
                                {variableIndex +
                                  1}

                              </Label>

                              <Input
                                type="text"
                                value={
                                  variableValues[
                                    templateKey
                                  ]?.[
                                    variableIndex
                                  ] || ""
                                }
                                onChange={(
                                  e
                                ) =>
                                  handleVariableChange(
                                    templateKey,
                                    variableIndex,
                                    e.target
                                      .value
                                  )
                                }
                                placeholder={`Enter value for Variable ${
                                  variableIndex +
                                  1
                                }`}
                                className="wa-variable-input"
                              />

                            </div>

                          )
                        )

                      )}

                      {/* =================================================
                          IMAGE
                      ================================================== */}

                      <div className="wa-image-section">

                        <div className="wa-image-title">

                          <ImageIcon
                            style={{
                              fontSize:
                                "15px",
                            }}
                          />

                          Template Image

                        </div>

                        <div className="wa-image-upload-row">

                          <input
                            ref={(
                              element
                            ) => {
                              fileInputRefs.current[
                                templateKey
                              ] =
                                element;
                            }}
                            type="file"
                            accept="image/*"
                            className="wa-image-input"
                            onChange={(
                              e
                            ) =>
                              handleImageSelect(
                                e,
                                template
                              )
                            }
                          />

                          <Button
                            outline
                            color="success"
                            size="sm"
                            type="button"
                            className="wa-choose-image-button"
                            onClick={() =>
                              openImageSelector(
                                template
                              )
                            }
                          >

                            <ImageIcon
                              style={{
                                fontSize:
                                  "15px",
                                verticalAlign:
                                  "middle",
                                marginRight:
                                  "4px",
                              }}
                            />

                            Choose Image

                          </Button>

                          {selectedImage && (

                            <Button
                              outline
                              color="danger"
                              size="sm"
                              type="button"
                              className="wa-remove-image-button"
                              onClick={() =>
                                handleRemoveImage(
                                  template
                                )
                              }
                            >

                              <CloseIcon
                                style={{
                                  fontSize:
                                    "15px",
                                  verticalAlign:
                                    "middle",
                                  marginRight:
                                    "3px",
                                }}
                              />

                              Remove

                            </Button>

                          )}

                        </div>

                        {selectedImage && (

                          <>

                            <div className="wa-selected-image-name">
                              {
                                selectedImage.name
                              }
                            </div>

                          </>

                        )}

                      </div>

                      {/* =================================================
                          LIVE PREVIEW
                      ================================================== */}

                      <div className="wa-preview-label">

                        <Visibility
                          style={{
                            fontSize:
                              "15px",
                          }}
                        />

                        Live Preview

                      </div>

                      <div className="wa-phone">

                        {/* PHONE HEADER */}

                        <div
                          className="wa-phone-header"
                          style={{
                            display:
                              "flex",
                            alignItems:
                              "center",
                            gap:
                              "8px",
                          }}
                        >

                          {getLogoUrl() && (

                            <img
                              src={getLogoUrl()}
                              alt="Branch Logo"
                              style={{
                                width:
                                  "28px",
                                height:
                                  "28px",
                                borderRadius:
                                  "50%",
                                objectFit:
                                  "cover",
                                background:
                                  "#fff",
                              }}
                              onError={(
                                e
                              ) => {
                                e.currentTarget.style.display =
                                  "none";
                              }}
                            />

                          )}

                          <span>
                            WhatsApp
                          </span>

                        </div>

                        <div className="wa-message">

                          {selectedImage && (

                            <img
                              src={
                                selectedImage.url
                              }
                              alt="WhatsApp preview"
                              className="wa-message-image"
                            />

                          )}

                          <div>
                            {renderPreviewText(
                              template
                            )}
                          </div>

                          <div className="wa-message-time">
                            12:45 PM
                          </div>

                        </div>

                      </div>

                    </CardContent>

                    {/* =================================================
                        FOOTER
                    ================================================== */}

                    <div
                      className="wa-card-footer"
                      style={{
                        display:
                          "flex",
                        alignItems:
                          "center",
                        justifyContent:
                          "space-between",
                        gap: "8px",
                        flexWrap:
                          "wrap",
                      }}
                    >

                      {/* VIEW */}

                      <Button
                        color="primary"
                        outline
                        size="sm"
                        type="button"
                        className="wa-view-button"
                        onClick={() =>
                          handleViewTemplate(
                            template
                          )
                        }
                      >

                        <Visibility
                          style={{
                            fontSize:
                              "16px",
                            verticalAlign:
                              "middle",
                            marginRight:
                              "4px",
                          }}
                        />

                        View

                      </Button>

                      <div
                        style={{
                          display:
                            "flex",
                          gap: "6px",
                          flexWrap:
                            "wrap",
                        }}
                      >

                        {/* =================================================
                            UPDATE ONLY
                        ================================================== */}

                        <Button
                          color="primary"
                          size="sm"
                          type="button"
                          disabled={isUpdating}
                          onClick={() =>
                            updateTemplate(
                              template
                            )
                          }
                        >

                          <EditIcon
                            style={{
                              fontSize:
                                "16px",
                              verticalAlign:
                                "middle",
                              marginRight:
                                "4px",
                            }}
                          />

                          {isUpdating
                            ? "Updating..."
                            : "Update"}

                        </Button>

                        {/* RESET */}

                        <Button
                          color="secondary"
                          outline
                          size="sm"
                          type="button"
                          onClick={() =>
                            handleResetTemplate(
                              template
                            )
                          }
                        >

                          <RefreshIcon
                            style={{
                              fontSize:
                                "16px",
                              verticalAlign:
                                "middle",
                              marginRight:
                                "3px",
                            }}
                          />

                          Reset

                        </Button>

                      </div>

                    </div>

                  </Card>

                </Col>

              );
            }
          )}

        </Row>

      )}

      {/* =====================================================
          VIEW MODAL
      ====================================================== */}

      {viewModal &&
        selectedTemplate &&
        (() => {

          const templateKey =
            getTemplateKey(
              selectedTemplate
            );

          const selectedImage =
            templateImages[
              templateKey
            ];

          const modalVariables =
            extractVariables(
              selectedTemplate.template
            );

          return (

            <div
              onClick={
                closeViewModal
              }
              style={{
                position:
                  "fixed",
                top: 0,
                left: 0,
                right: 0,
                bottom: 0,
                background:
                  "rgba(0, 0, 0, 0.55)",
                zIndex: 9999,
                display:
                  "flex",
                alignItems:
                  "center",
                justifyContent:
                  "center",
                padding:
                  "20px",
              }}
            >

              <div
                onClick={(e) =>
                  e.stopPropagation()
                }
                style={{
                  background:
                    "#fff",
                  width:
                    "100%",
                  maxWidth:
                    "650px",
                  maxHeight:
                    "90vh",
                  overflowY:
                    "auto",
                  borderRadius:
                    "16px",
                  boxShadow:
                    "0 20px 60px rgba(0,0,0,0.25)",
                }}
              >

                {/* MODAL HEADER */}

                <div
                  style={{
                    padding:
                      "16px 20px",
                    borderBottom:
                      "1px solid #eef1f2",
                    display:
                      "flex",
                    alignItems:
                      "center",
                    justifyContent:
                      "space-between",
                  }}
                >

                  <div>

                    <Typography
                      variant="h6"
                      style={{
                        fontWeight:
                          700,
                      }}
                    >
                      {
                        selectedTemplate.template_type
                      }
                    </Typography>

                    <Typography
                      variant="caption"
                      style={{
                        color:
                          "#8a969c",
                      }}
                    >
                      {
                        selectedTemplate.template_id
                      }
                    </Typography>

                  </div>

                  <Button
                    color="link"
                    type="button"
                    onClick={
                      closeViewModal
                    }
                    style={{
                      fontSize:
                        "22px",
                      color:
                        "#555",
                      textDecoration:
                        "none",
                    }}
                  >

                    <CloseIcon />

                  </Button>

                </div>

                {/* MODAL BODY */}

                <div
                  style={{
                    padding:
                      "20px",
                  }}
                >

                  {/* VARIABLES */}

                  {modalVariables.length >
                    0 && (

                    <>

                      <div className="wa-preview-label">

                        <MessageIcon
                          style={{
                            fontSize:
                              "16px",
                          }}
                        />

                        Template Variables

                      </div>

                      {modalVariables.map(
                        (
                          variable,
                          variableIndex
                        ) => (

                          <div
                            key={`${templateKey}-modal-${variableIndex}`}
                            className="wa-variable-box"
                          >

                            <Label className="wa-variable-label">

                              Variable{" "}
                              {variableIndex +
                                1}

                            </Label>

                            <Input
                              type="text"
                              value={
                                variableValues[
                                  templateKey
                                ]?.[
                                  variableIndex
                                ] || ""
                              }
                              onChange={(
                                e
                              ) =>
                                handleVariableChange(
                                  templateKey,
                                  variableIndex,
                                  e.target
                                    .value
                                )
                              }
                              placeholder={`Enter value for Variable ${
                                variableIndex +
                                1
                              }`}
                              className="wa-variable-input"
                            />

                          </div>

                        )
                      )}

                    </>

                  )}

                  {/* MESSAGE */}

                  <div className="wa-preview-label">

                    <MessageIcon
                      style={{
                        fontSize:
                          "16px",
                      }}
                    />

                    Template Message

                  </div>

                  <div
                    style={{
                      background:
                        "#f7f9fa",
                      border:
                        "1px solid #e4e9eb",
                      borderRadius:
                        "10px",
                      padding:
                        "15px",
                      fontSize:
                        "14px",
                      lineHeight:
                        1.7,
                      whiteSpace:
                        "pre-wrap",
                      wordBreak:
                        "break-word",
                    }}
                  >

                    {
                      selectedTemplate.template
                    }

                  </div>

                  {/* IMAGE */}

                  {selectedImage && (

                    <>

                      <div className="wa-preview-label">

                        <ImageIcon
                          style={{
                            fontSize:
                              "16px",
                          }}
                        />

                        Selected Image

                      </div>

                      <div className="wa-image-preview-box">

                        <img
                          src={
                            selectedImage.url
                          }
                          alt="Selected template"
                          className="wa-image-preview"
                          style={{
                            maxHeight:
                              "300px",
                          }}
                        />

                      </div>

                    </>

                  )}

                  {/* WHATSAPP PREVIEW */}

                  <div className="wa-preview-label">

                    <Visibility
                      style={{
                        fontSize:
                          "16px",
                      }}
                    />

                    WhatsApp Preview

                  </div>

                  <div
                    className="wa-phone"
                    style={{
                      maxWidth:
                        "420px",
                      margin:
                        "0 auto",
                    }}
                  >

                    {/* PHONE HEADER WITH LOGO */}

                    <div
                      className="wa-phone-header"
                      style={{
                        display:
                          "flex",
                        alignItems:
                          "center",
                        gap:
                          "8px",
                      }}
                    >

                      {getLogoUrl() && (

                        <img
                          src={getLogoUrl()}
                          alt="Branch Logo"
                          style={{
                            width:
                              "30px",
                            height:
                              "30px",
                            borderRadius:
                              "50%",
                            objectFit:
                              "cover",
                            background:
                              "#fff",
                          }}
                          onError={(
                            e
                          ) => {
                            e.currentTarget.style.display =
                              "none";
                          }}
                        />

                      )}

                      <span>
                        WhatsApp
                      </span>

                    </div>

                    <div className="wa-message">

                      {selectedImage && (

                        <img
                          src={
                            selectedImage.url
                          }
                          alt="WhatsApp preview"
                          className="wa-message-image"
                        />

                      )}

                      <div>
                        {renderPreviewText(
                          selectedTemplate
                        )}
                      </div>

                      <div className="wa-message-time">
                        12:45 PM
                      </div>

                    </div>

                  </div>

                </div>

                {/* MODAL FOOTER */}

                <div
                  style={{
                    padding:
                      "12px 20px",
                    borderTop:
                      "1px solid #eef1f2",
                    textAlign:
                      "right",
                  }}
                >

                  <Button
                    color="secondary"
                    outline
                    type="button"
                    onClick={
                      closeViewModal
                    }
                  >
                    Close
                  </Button>

                </div>

              </div>

            </div>

          );
        })()}

    </div>
  );
};

export default WhatsAppTemplate;